import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Skeleton,
} from '@mui/material';
import dayjs from 'dayjs';

import api from '../../../../utils/functions/api';

// ประวัติรายการเบิกจริงที่เคยสร้างจาก template — เปิดเมื่อมี templateId (ไม่ null) ดึงข้อมูลเองจาก
// GET /expenses-recurring/:id/history ทุกครั้งที่ templateId เปลี่ยน parent แค่ถือว่ากำลังดู template ไหนอยู่
export default function RecurringHistoryDialog({ templateId, onClose }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!templateId) return;
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const { data } = await api.get(`${process.env.REACT_APP_API_URL}/expenses-recurring/${templateId}/history`);
        if (!cancelled) setRows(data?.rows || []);
      } catch (error) {
        console.error(error);
        if (!cancelled) setRows([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [templateId]);

  return (
    <Dialog open={!!templateId} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>ประวัติรายการเบิกที่เคยสร้าง</DialogTitle>
      <DialogContent dividers>
        {loading && <Skeleton height={40} />}
        {!loading && rows.length === 0 && (
          <Typography variant="body2" color="text.secondary">ยังไม่เคยสร้างรายการเบิกจากตัวนี้</Typography>
        )}
        {!loading && rows.map((h) => (
          <Box key={h._id} sx={{ display: 'flex', justifyContent: 'space-between', py: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Box>
              <Typography variant="body2">{dayjs(h.date).format('DD/MM/YYYY')}</Typography>
              <Chip size="small" label={h.status} sx={{ mt: 0.5 }} />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {Number(h.price || 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })}
            </Typography>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>ปิด</Button>
      </DialogActions>
    </Dialog>
  );
}
